module.exports = __webpack_public_path__ + "static/media/background.3ac09596.jpg";